export default __webpack_public_path__ + "static/media/cancel.0dd7a916.svg";